/**
 * Minimo indispensabile su IndexedDB, senza dipendenze.
 * localStorage non basta: la coda dei rapportini deve sopravvivere alla chiusura
 * dell'app, reggere oggetti strutturati e non avere il limite dei 5 MB.
 */

const NOME_DB = 'teraworks';
const VERSIONE = 1;
export const DEPOSITO_CODA = 'coda-rapportini';

let promessa: Promise<IDBDatabase> | null = null;

function apri(): Promise<IDBDatabase> {
  if (promessa) return promessa;

  promessa = new Promise((risolvi, rifiuta) => {
    const richiesta = indexedDB.open(NOME_DB, VERSIONE);

    richiesta.onupgradeneeded = () => {
      const db = richiesta.result;
      if (!db.objectStoreNames.contains(DEPOSITO_CODA)) {
        db.createObjectStore(DEPOSITO_CODA, { keyPath: 'idDispositivo' });
      }
    };

    richiesta.onsuccess = () => risolvi(richiesta.result);
    richiesta.onerror = () => rifiuta(richiesta.error ?? new Error('IndexedDB non disponibile.'));
  });

  return promessa;
}

async function transazione<T>(
  deposito: string,
  modo: IDBTransactionMode,
  azione: (store: IDBObjectStore) => IDBRequest<T>,
): Promise<T> {
  const db = await apri();
  return new Promise((risolvi, rifiuta) => {
    const tx = db.transaction(deposito, modo);
    const richiesta = azione(tx.objectStore(deposito));
    richiesta.onsuccess = () => risolvi(richiesta.result);
    richiesta.onerror = () => rifiuta(richiesta.error ?? new Error('Operazione IndexedDB fallita.'));
  });
}

export const idb = {
  salva: <T>(deposito: string, valore: T) =>
    transazione(deposito, 'readwrite', (store) => store.put(valore as unknown as object)),

  leggiTutti: <T>(deposito: string) =>
    transazione<T[]>(deposito, 'readonly', (store) => store.getAll() as IDBRequest<T[]>),

  elimina: (deposito: string, chiave: IDBValidKey) =>
    transazione(deposito, 'readwrite', (store) => store.delete(chiave)),

  conta: (deposito: string) =>
    transazione<number>(deposito, 'readonly', (store) => store.count()),
};
